import config from 'roomba/config/environment';
export const googleAuthUrl = () => {
  return `${config.roombaBase}/auth/google`;
};
export const microsoftAuthUrl = () => {
  return `${config.roombaBase}/auth/microsoft/service`;
};
export const microsoftOfficeUrl = () => {
  return `${config.roombaBase}/auth/microsoft/user`;
};